export default __webpack_public_path__ + "tutorial-3@1x.c661e990.png";